import { makeUseAxios } from "axios-hooks";

import { Config } from "@/utils/config.utils";

import { createApiFor, ExtendedUseAxios } from "./utils";

const useCartServiceApi = makeUseAxios({
    axios: createApiFor(`/cartservice/${Config.general.basestore}`),
    defaultOptions: {
        ssr: false,
        manual: false
    }
}) as ExtendedUseAxios;

const useBFFCartServiceApi = makeUseAxios({
    axios: createApiFor(`/${Config.general.basestore}`, {
        bff: true
    }),
    defaultOptions: {
        ssr: false,
        manual: false
    }
}) as ExtendedUseAxios;

export { useBFFCartServiceApi, useCartServiceApi };
